export const API_URL = import.meta.env.VITE_APP_API_BASE_URL as string;
export const PDF_MAX_SIZE = Number(import.meta.env.VITE_APP_PDF_MAX_SIZE);
export const PDF_START_DATE = new Date(import.meta.env.VITE_APP_PDF_START_DATE);
export const PDF_START_DEFAULT_DATE = new Date(
  import.meta.env.VITE_APP_PDF_START_DATE_DEFAULT
);
export const REQUEST_INPUT_TEXT_MINIMUM_LENGTH = Number(
  import.meta.env.VITE_APP_REQUEST_INPUT_TEXT_MINIMUM_LENGTH
);
export const PUBLIC_POSTHOG_KEY = import.meta.env
  .VITE_APP_PUBLIC_POSTHOG_KEY as string;
export const PUBLIC_POSTHOG_HOST = import.meta.env
  .VITE_APP_PUBLIC_POSTHOG_HOST as string;
